import React from "react";

import {component_tool} from "../../tool";

let {WizModal} = component_tool

let componentName = 'permissions';

const columns = (self) => {
  let {specialBizId} =  self.state;

  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "业务类型",
      name: "specialBizId",
      dataIndex: "specialBizId",
      dict:[
        {code: 0, codeName: '课程'},
        {code: 1, codeName: '考试'},
        {code: 2, codeName: '问卷'},
        {code: 3, codeName: '公告'},
        {code: 5, codeName: '证书'},
        {code: 6, codeName: '资源下载'},
        {code: 7, codeName: '最新资讯'},
        {code: 8, codeName: '班级'},
        {code: 9, codeName: '报名'},
        {code: 10, codeName: '作业'},
        {code: 11, codeName: '路径'},
        {code: 4, codeName: '路径-必修'},
        {code: 12, codeName: '路径-选修'},
        {code: 13, codeName: '培训主题'},
      ],
      tableItem: {
        width: 80,
      },
      searchItem: {
        type: 'select',
        rules: [
          {required: true, message: '请选择业务类型'}
        ]
      }
    },
    specialBizId === undefined || specialBizId === 0 ? {
      title: "编码",
      name: "bizCode",
      tableItem: {},
    } : {},
    {
      title: "业务内容",
      name: "bizName",
      dataIndex: "bizName",
      tableItem: {},
      searchItem: {}
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            self.setState(value)
            return value;
          },
          buttonSort: ['batchSet'],
          buttons: [
            {
              key: 'batchSet',
              name: 'WizButton',
              params: {
                children: '批量设置',
                type: 'primary'
              },
              onClick :(e) =>{
                if (e && e.rows && e.rows.length) {
                  let record = e.rows;

                  self.jumpPage('push', '/permissions/add', record)
                } else {
                  WizModal.confirm({
                    title: '至少选择一条数据',
                    onOk: () => {},
                    onCancel() {}
                  })
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          // rowKey: (record) => (record.bizType + '-' + record.id),
          rowKey: 'id',
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          pageSizeOptions: [
            '10', '20', '40', '60', '200'
          ],
        },
        rowOperateSort: [],
        rowOperateView: [
        ],
        commonOperate: {},
        showAuth: [
          {
            title: "受众范围",
            text: '查看',
            dataIndex: "targetScope",
            width: 150
          },
          {
            title: "管理权限",
            text: '查看',
            dataIndex: "managerTargetScope",
            width: 150
          },
        ],
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
